<div class="container">
  <!-- Left Panel -->
  <div class="left-panel">
    <div class="filters">
      <div class="filter-group">
        <label for="workspace">Workspace</label>
        <select id="workspace" [(ngModel)]="selectedWorkspace" (change)="onWorkspaceChange()">
          <option *ngFor="let workspace of workspaces" [value]="workspace">{{ workspace }}</option>
        </select>
      </div>
    </div>

    <table class="item-table">
      <thead>
        <tr>
          <th style="width: 70%;">Name</th>
          <th style="width: 30%;">Status</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let notebook of notebooks" (click)="selectNotebook(notebook)"
          [class.active]="selected === notebook">
          <td style="width: 70%;">{{ notebook.name }}</td>
          <td style="width: 30%;">
            <span class="status-tag" [ngClass]="notebook.status">{{ notebook.status }}</span>
          </td>
        </tr>
      </tbody>
    </table>

    <!-- No data message -->
    <div *ngIf="!isLoading && filteredNotebooks.length === 0" class="no-data-message">
      No data available
    </div>
  </div>

  <!-- Right Panel -->
  <div class="right-panel">
    <div class="actions">
      <button class="btn btn-primary"
        [disabled]="parameterFields.length === 0 || isEditMode || !selectedNotebook?.id || runningItemIds.has(selectedNotebook!.id)"
        (click)="runNotebook(selectedNotebook!.id)">
        <span class="material-icons">play_arrow</span> Run
      </button>
      <button class="btn btn-outline"
        [disabled]="!isEditMode || parameterFields.length === 0 || runningItemIds.has(selectedNotebook!.id)"
        (click)="saveNotebook()">
        <span class="material-icons">save</span> Save
      </button>
      <button class="btn btn-outline"
        [disabled]="!selected || isEditMode || parameterFields.length === 0 || runningItemIds.has(selectedNotebook!.id)"
        (click)="editNotebook()">
        <span class="material-icons">edit</span> Edit
      </button>
    </div>

    <div class="selected-info" *ngIf="selectedNotebook">
      <p><strong>Name:</strong> {{ selectedNotebook.name }}</p>
      <p>
        <strong>Status:</strong>
        <span class="status-tag" [ngClass]="selectedNotebook.status">{{ selectedNotebook.status }}</span>
      </p>
      <div *ngIf="selectedNotebook.status === 'Timeout'" class="timeout-message">
        Operation timed out after 1 hour. Please check the status directly in Microsoft Fabric.
      </div>
      <p><strong>Description:</strong> {{ selectedNotebook.description || 'No description available' }}</p>
    </div>
    <div class="details">
      <div *ngIf="selectedNotebook && combinations.length === 0 && !areCombinationsLoading">
        <p *ngIf="parameterFields.length > 0"><strong>Parameters:</strong></p>
        <div class="input-group" *ngFor="let field of parameterFields">
          <label [for]="'field_' + field.label">{{ field.label }}</label>
          <input [id]="'field_' + field.label" type="text" [(ngModel)]="field.value" [value]="field.value"
            placeholder="{{ field.value }}" [disabled]="!isEditMode" />
        </div>
      </div>
      <div *ngIf="selectedNotebook && combinations.length > 0 && !areCombinationsLoading">
        <p *ngIf="parameterFields.length > 0"><strong>Parameters:</strong></p>
        <div *ngIf="parameterFields.length > 0" class="info-group">
          <div class="info-icon-container">
            <mat-icon class="info-icon">info</mat-icon>
          </div>
          <span class="info-text">Select the parameters in the following order: system, company, source_table/endpoint, target_table.</span>
        </div>
        <div class="input-group" *ngFor="let field of parameterFields; let i = index">
          <label [for]="'field_' + field.label">{{ field.label }}</label>
          <ng-container [ngSwitch]="field.label.toLowerCase()">
            <select *ngSwitchCase="'system'" [id]="'field_' + field.label" [(ngModel)]="field.value"  
              (ngModelChange)="setParameter(field.label,$event)" [disabled]="!isEditMode">
              <option *ngFor="let option of getSystemOptions()" [value]="option">{{ option }}</option>
            </select>
            <select *ngSwitchCase="'company'" [id]="'field_' + field.label" [(ngModel)]="field.value"
              (ngModelChange)="setParameter(field.label,$event)" [disabled]="!isEditMode">
              <option value="" disabled selected>Select company</option>
              <option *ngFor="let option of getCompanyOptions()" [value]="option" [disabled]="!system">{{ option
                }}</option>
            </select>
            <select *ngSwitchCase="'endpoint'" [id]="'field_' + field.label" [(ngModel)]="field.value"
              (ngModelChange)="setParameter(field.label,$event)" [disabled]="!isEditMode">
              <option value="" disabled selected>Please select company first</option>
              <option *ngFor="let option of getSourceTableOptions()" [value]="option" [disabled]="!system || !company">{{ option }}</option>
            </select>
            <select *ngSwitchCase="'source_table'" [id]="'field_' + field.label" [(ngModel)]="field.value"
              (ngModelChange)="setParameter(field.label,$event)" [disabled]="!isEditMode">
              <option value="" disabled selected>Please select company first</option>
              <option *ngFor="let option of getSourceTableOptions()" [value]="option" [disabled]="!system || !company">{{ option }}</option>
            </select>
            <select *ngSwitchCase="'target_table'" [id]="'field_' + field.label" [(ngModel)]="field.value"
              (ngModelChange)="setParameter(field.label,$event)" [disabled]="!isEditMode">
              <option value="" disabled selected>Please select source_table/endpoint first</option>
              <option *ngFor="let option of getTargetTableOptions()" [value]="option" [disabled]="!system || !company || !sourceTable">{{ option }}</option>
            </select>
            <input *ngSwitchDefault [id]="'field_' + field.label" type="text" [(ngModel)]="field.value"
              placeholder="{{ field.value }}" [disabled]="!isEditMode" />
          </ng-container>
        </div>
      </div>

      <div *ngIf="parameterFields.length === 0 && selectedNotebook" class="no-params-message">
        No parameters available
      </div>
    </div>

    <div class="right-panel-overlay" *ngIf="areParamsLoading || areCombinationsLoading">
      <mat-spinner diameter="30"></mat-spinner>
    </div>
  </div>

  <!-- Loading overlay -->
  <div class="loading-overlay" *ngIf="isLoading">
    <mat-spinner diameter="50"></mat-spinner>
  </div>
</div>